module.exports = __webpack_public_path__ + "img/luckyDrow.65b4a1bc.jpg";